/** slotId -> formId, or null for a slot that's intentionally showing nothing. */
export type SlotRegistry = Record<string, string | null>;

const cache = new Map<string, Promise<SlotRegistry>>();

/**
 * Fetches the shared /slots.json registry relative to the embed script's own
 * origin. Missing file or bad response degrades to an empty registry rather
 * than throwing, since not every site needs slots.
 */
export function loadSlotRegistry(originUrl: string): Promise<SlotRegistry> {
  let pending = cache.get(originUrl);
  if (!pending) {
    pending = fetch(`${originUrl}/slots.json`, { credentials: "omit" })
      .then((res) => (res.ok ? (res.json() as Promise<SlotRegistry>) : {}))
      .catch(() => ({}));
    cache.set(originUrl, pending);
  }
  return pending;
}
